let ctx;
const tone = (freq, start, dur, type = "sine") => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0.25, ctx.currentTime + start);
  g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
  o.connect(g).connect(ctx.destination);
  o.start(ctx.currentTime + start); o.stop(ctx.currentTime + start + dur);
};

// kind: "success" (rising double beep) | "warn" (single low) | "error" (low buzz)
export const scanFeedback = (kind = "success") => {
  const play = () => {
    if (kind === "success") { tone(880, 0, 0.12); tone(1320, 0.14, 0.18); }
    else if (kind === "warn") tone(520, 0, 0.3);
    else tone(180, 0, 0.45, "square");
  };
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "running") play();
    else {
      ctx.resume().then(() => play()).catch(() => {});
      // autoplay blocked until a gesture: play on first touch/click
      const once = () => { ctx.resume().then(play).catch(() => {}); };
      document.addEventListener("pointerdown", once, { once: true });
    }
  } catch { /* Web Audio unsupported — skip beep */ }
  try {
    navigator.vibrate?.(kind === "success" ? [80, 40, 80] : kind === "warn" ? 200 : [300, 100, 300]);
  } catch { /* Vibration API unsupported — skip */ }
};
